"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Feature = require("./Feature");
Object.keys(_Feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Feature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Feature[key];
    }
  });
});